import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=0545bd5d&scoped=true&"
import script from "./Calculator.vue?vue&type=script&lang=js&"
export * from "./Calculator.vue?vue&type=script&lang=js&"
import style0 from "./Calculator.vue?vue&type=style&index=0&id=0545bd5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545bd5d",
  null
  
)

export default component.exports